<template>
    <div>
    <order-paymentstatus :orderid="this.$route.params.order" :key="'paymentstatus'+$route.params.order">
    </order-paymentstatus>
    </div>

</template>

<script>
  export default {

  //  created:async function(){
  //       let token = this.$route.params.order;
  //       this.loadOrder(token)
  //   },

    
  //   beforeRouteUpdate (to, from, next) {
  //       let token = to.params.order;
  //       this.loadOrder(token)
  //       next()
  //   },


  }
</script>

<style>

</style>
